import { render, staticRenderFns } from "./layouts.vue?vue&type=template&id=3decad08&"
import script from "./layouts.vue?vue&type=script&lang=js&"
export * from "./layouts.vue?vue&type=script&lang=js&"
import style0 from "./layouts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports